export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="py-12 bg-obsidian border-t border-concrete/10"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo/Name */}
          <div className="flex items-center gap-4">
            <span className="font-heading text-2xl font-bold text-concrete tracking-tight">
              LTVT
            </span>
          </div>

          {/* Copyright */}
          <p className="text-xs text-concrete/40 uppercase tracking-wider">
            © {currentYear} All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
